import React, { Component } from 'react';
import PropTypes from 'prop-types';

import {
  dataTable,
} from 'client/helpers/dataTables';

import {
  DATA_TABLE_VIEW_ID_PARTNER_LISTINGS_ALL,
  DATA_TABLE_VIEW_ID_PARTNER_LISTINGS_APP_IN_PROGRESS,
} from 'common/dataTableConstants';

import SrUserSettingDropdownWithSearchBar from 'client/components/SrUserSettingDropdownWithSearchBar/SrUserSettingDropdownWithSearchBar';
import SrPartnerSection from 'client/components/SrPartnerSection';
import SrText from 'client/components/SrText';
import branch from 'client/core/branch';

import SrDataTablePartnerListings, {
  getDataTableSettingsFromProps,
} from 'client/components/SrDataTablePartnerListings';

const filterOptions = [
  {
    label: 'All',
    value: DATA_TABLE_VIEW_ID_PARTNER_LISTINGS_ALL,
  },
  {
    label: 'Apps In Progress',
    value: DATA_TABLE_VIEW_ID_PARTNER_LISTINGS_APP_IN_PROGRESS,
  },
];

@dataTable(getDataTableSettingsFromProps)
@branch({
  partnerListingsViewId: ['partners', 'listingsViewId'],
  currentUser: ['currentUser'],
})
class SrDataTablePartnerListingsSection extends Component {
  static propTypes = {
    dispatch: PropTypes.func.isRequired,
    partner: PropTypes.object.isRequired,
    sinceDate: PropTypes.string,
    apartment: PropTypes.object,
    apartmentBuildingId: PropTypes.array,
    partnerListingsViewId: PropTypes.string,
    items: PropTypes.array.isRequired,
    dataTableApiState: PropTypes.object.isRequired,
  }

  UNSAFE_componentWillMount() {
    const { partnerListingsViewId } = this.props;
    if (!partnerListingsViewId) {
      this._onFilterClick(DATA_TABLE_VIEW_ID_PARTNER_LISTINGS_ALL);
    }
  }

  _onFilterClick = (viewId) => {
    const { dispatch } = this.props;
    dispatch(({ state }) => {
      state.set(['partners', 'listingsViewId'], viewId);
      state.commit();
    });
  }

  render() {
    const {
      partner,
      sinceDate,
      apartment,
      apartmentBuildingId,
      partnerListingsViewId,
      dataTableIsFullyLoaded,
      dataTableApiState,
      items,
    } = this.props;

    if (
      (
        dataTableIsFullyLoaded
        && !dataTableApiState.inProgress
        && !items.length
      )
      || (
        !partnerListingsViewId
      )
    ) {
      return null;
    }

    return (
      <SrPartnerSection
        title='Active Homes'
        headerRow={
          <div className='partnerDataTableFilterContainer flex' style={{ lineHeight: '40px' }}>
            {partner && partner.markets?.length > 1 && (
              <SrUserSettingDropdownWithSearchBar
                title='Market'
                notFoundTitle='No markets found'
                settingField={`partnerPortal.activeListings.${partner.slug}_marketIds`}
                dropdownOptions={partner.markets.map((option) => ({
                  label: option.displayNameFull,
                  value: option.marketId,
                }))}
              />
            )}
            {filterOptions.map(({ label, value }) => {
              const isActive = value === partnerListingsViewId;
              return (
                <div
                  key={value}
                  className='partnerDataTableFilterOptionWrapper'
                >
                  <SrText
                    size='large'
                    weight='medium'
                    color='blueGreycliff'
                    cursor={isActive ? null : 'pointer'}
                    decoration={isActive ? 'underline-yellow' : null}
                    font='greycliff'
                    opacity={isActive ? null : 0.5}
                    onClick={isActive ? null : () => this._onFilterClick(value)}
                    className='partnerDataTableFilterOption'
                  >
                    {label}
                  </SrText>
                </div>
              );
            })}
          </div>
        }
      >
        <SrDataTablePartnerListings
          partner={partner}
          sinceDate={sinceDate}
          apartment={apartment}
          apartmentBuildingId={apartmentBuildingId}
          partnerListingsViewId={partnerListingsViewId}
        />
      </SrPartnerSection>
    );
  }
}

SrDataTablePartnerListingsSection.displayName = 'SrDataTablePartnerListingsSection';

export default SrDataTablePartnerListingsSection;
